<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="订单号">
                <a-input v-model="queryParam.orderNo" placeholder="订单号" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="状态">
                <a-select
                  v-model="queryParam.status"
                  placeholder="全部"
                  allow-clear
                  style="width: 100%"
                  @change="onStatusChange"
                >
                  <a-select-option :value="1">待审核</a-select-option>
                  <a-select-option :value="2">已兑换</a-select-option>
                  <a-select-option :value="3">驳回</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <a-button style="margin-left: 8px" @click="openPhraseManage"><a-icon type="setting" />驳回话术</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-table :loading="loading" rowKey="id" :columns="columns" :data-source="list" :pagination="false">
        <span slot="status" slot-scope="text">
          <a-tag v-if="text === 1" color="orange">待审核</a-tag>
          <a-tag v-else-if="text === 2" color="green">已兑换</a-tag>
          <a-tag v-else color="red">驳回</a-tag>
        </span>
        <span slot="quantity" slot-scope="text">
          {{ text || 1 }} 张
        </span>
        <span slot="operation" slot-scope="text, record">
          <a v-if="needsClaim(record)" @click="claimOrder(record)">接单</a>
          <template v-else-if="canAuditActions(record) && record.status === 1">
            <a @click="showDetail(record)">明细</a>
            <a-divider type="vertical" />
            <a @click="handleAudit(record, 2)">通过</a>
            <a-divider type="vertical" />
            <a @click="showReject(record)">驳回</a>
          </template>
          <a v-else-if="!isProcessable(record)" @click="showDetail(record)">详情</a>
        </span>
      </a-table>
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        @change="changePage"
        @showSizeChange="changeSize"
      />

      <a-modal title="驳回订单" :visible="rejectVisible" :confirm-loading="rejectSubmitting" @ok="confirmReject" @cancel="closeReject">
        <a-spin :spinning="phraseLoading">
          <a-form-model layout="vertical">
            <a-form-model-item label="选择话术">
              <a-radio-group v-model="selectedPhraseKey">
                <div v-for="item in rejectPhrases" :key="item.id" class="phrase-radio">
                  <a-radio :value="'p-' + item.id">{{ item.title }}</a-radio>
                </div>
                <div class="phrase-radio">
                  <a-radio value="custom">自定义</a-radio>
                </div>
              </a-radio-group>
            </a-form-model-item>
            <a-form-model-item label="驳回原因（可编辑）" required>
              <a-textarea v-model="rejectReason" rows="4" placeholder="请选择话术或输入自定义驳回原因" />
            </a-form-model-item>
            <a-form-model-item label="驳回图片（可多选）">
              <file-upload
                :value="rejectImageUrls"
                type="image"
                :count="9"
                field-name="rejectImageUrls"
                @change="onRejectImagesChange"
              />
            </a-form-model-item>
          </a-form-model>
        </a-spin>
      </a-modal>

      <a-modal title="驳回话术管理" :visible="phraseManageVisible" width="760px" :footer="null" @cancel="phraseManageVisible = false">
        <div style="margin-bottom: 12px">
          <a-button type="primary" icon="plus" @click="openPhraseForm()">新增话术</a-button>
        </div>
        <a-table rowKey="id" size="small" :loading="phraseManageLoading" :columns="phraseColumns" :data-source="phraseManageList" :pagination="false">
          <span slot="status" slot-scope="text">
            <a-tag v-if="text === 1" color="green">启用</a-tag>
            <a-tag v-else>禁用</a-tag>
          </span>
          <span slot="phraseOp" slot-scope="text, record">
            <a @click="openPhraseForm(record)">编辑</a>
            <a-divider type="vertical" />
            <a-popconfirm title="确认删除该话术？" @confirm="removePhrase(record.id)">
              <a style="color: #ff4d4f">删除</a>
            </a-popconfirm>
          </span>
        </a-table>
      </a-modal>

      <a-modal
        :title="phraseForm.id ? '编辑话术' : '新增话术'"
        :visible="phraseFormVisible"
        :confirm-loading="phraseFormSubmitting"
        @ok="submitPhraseForm"
        @cancel="phraseFormVisible = false"
      >
        <a-form-model layout="vertical">
          <a-form-model-item label="标题" required>
            <a-input v-model="phraseForm.title" placeholder="如：卡图不清晰" />
          </a-form-model-item>
          <a-form-model-item label="话术内容" required>
            <a-textarea v-model="phraseForm.content" rows="4" placeholder="发送给用户的驳回说明" />
          </a-form-model-item>
          <a-form-model-item label="排序">
            <a-input-number v-model="phraseForm.sort" :min="0" style="width: 100%" />
          </a-form-model-item>
          <a-form-model-item label="状态">
            <a-radio-group v-model="phraseForm.status">
              <a-radio :value="1">启用</a-radio>
              <a-radio :value="0">禁用</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-form-model>
      </a-modal>

      <a-modal title="礼品卡明细" :visible="detailVisible" :footer="null" width="860px" @cancel="detailVisible = false">
        <a-spin :spinning="detailLoading">
          <template v-if="detail">
            <a-descriptions bordered size="small" :column="2" class="detail-summary">
              <a-descriptions-item label="订单号" :span="2">{{ detail.orderNo }}</a-descriptions-item>
              <a-descriptions-item label="用户ID">{{ detail.userId }}</a-descriptions-item>
              <a-descriptions-item label="状态">
                <a-tag v-if="detail.status === 1" color="orange">待审核</a-tag>
                <a-tag v-else-if="detail.status === 2" color="green">已兑换</a-tag>
                <a-tag v-else color="red">驳回</a-tag>
              </a-descriptions-item>
              <a-descriptions-item label="卡种">{{ detail.categoryName || '—' }}</a-descriptions-item>
              <a-descriptions-item label="国家">{{ detail.countryName || '—' }}</a-descriptions-item>
              <a-descriptions-item label="卡类型">{{ detail.cardTypeName || '—' }}</a-descriptions-item>
              <a-descriptions-item label="Redeem Value">
                {{ formatFaceValue(detail) }}
              </a-descriptions-item>
              <a-descriptions-item label="张数">{{ detail.quantity || (detail.cards || []).length || 1 }} 张</a-descriptions-item>
              <a-descriptions-item label="券加成">
                {{ formatCouponBonus(detail) }}
              </a-descriptions-item>
              <a-descriptions-item label="到账金额" :span="2">
                {{ payoutCurrencySymbol }}{{ detail.cashAmount }}
              </a-descriptions-item>
              <a-descriptions-item v-if="detail.comment" label="用户备注" :span="2">{{ detail.comment }}</a-descriptions-item>
              <a-descriptions-item label="提交时间" :span="2">{{ detail.createTime }}</a-descriptions-item>
            </a-descriptions>
            <div v-if="detail.status === 3 && detail.rejectReason" class="reject-block">
              <div class="card-title">驳回原因</div>
              <p>{{ detail.rejectReason }}</p>
              <div v-if="splitImageUrls(detail.rejectImageUrls).length" class="img-row">
                <img
                  v-for="(img, i) in splitImageUrls(detail.rejectImageUrls)"
                  :key="'rj-' + i"
                  v-image-preview
                  :src="img"
                  class="card-img clickable"
                />
              </div>
            </div>
            <div class="cards-section-title">礼品卡明细（共 {{ (detail.cards || []).length }} 张）</div>
            <div v-for="card in detail.cards || []" :key="card.id || card.sortOrder" class="card-block">
              <div class="card-title">第 {{ card.sortOrder }} 张</div>
              <a-descriptions size="small" :column="1" class="card-desc">
                <a-descriptions-item label="Redeem Value">
                  {{ formatCardFaceValue(card, detail) }}
                </a-descriptions-item>
                <a-descriptions-item label="Rate">
                  {{ formatCardRate(card) }}
                </a-descriptions-item>
                <a-descriptions-item label="卡号">{{ card.cardNumber || '—' }}</a-descriptions-item>
                <a-descriptions-item label="有效期">{{ card.cardExpiry || '—' }}</a-descriptions-item>
                <a-descriptions-item label="PIN">{{ card.cardPin || '—' }}</a-descriptions-item>
              </a-descriptions>
              <div v-if="card.imgUrls" class="img-row">
                <div class="img-label">卡图</div>
                <img
                  v-for="(img, i) in splitImageUrls(card.imgUrls)"
                  :key="i"
                  v-image-preview
                  :src="img"
                  class="card-img-lg clickable"
                />
              </div>
              <div v-else class="no-img">未上传卡图</div>
            </div>
          </template>
        </a-spin>
      </a-modal>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import {
  pageRedeemOrder,
  getRedeemOrderDetail,
  auditRedeemOrder,
  claimRedeemOrder,
  listRejectPhrases,
  saveRejectPhrase,
  deleteRejectPhrase
} from '@/api/giftcard/redeem'
import { mapGetters } from 'vuex'

const BIZ_TYPE_REDEEM = 1
const LIST_POLL_MS = 5000

export default {
  name: 'GiftcardRedeem',
  data() {
    return {
      loading: false,
      detailLoading: false,
      phraseLoading: false,
      rejectSubmitting: false,
      phraseManageLoading: false,
      phraseFormSubmitting: false,
      list: [],
      total: 0,
      listPollTimer: null,
      rejectVisible: false,
      detailVisible: false,
      phraseManageVisible: false,
      phraseFormVisible: false,
      rejectReason: '',
      rejectImageUrls: '',
      selectedPhraseKey: 'custom',
      rejectPhrases: [],
      phraseManageList: [],
      currentRecord: null,
      detail: null,
      phraseForm: {},
      queryParam: { pageNum: 1, pageSize: 10, status: undefined, orderNo: undefined },
      columns: [
        { title: '订单号', dataIndex: 'orderNo', width: 170 },
        { title: '用户ID', dataIndex: 'userId', width: 90 },
        { title: '卡种', dataIndex: 'categoryName', width: 110, ellipsis: true },
        { title: '国家', dataIndex: 'countryName', width: 100, ellipsis: true },
        { title: '张数', dataIndex: 'quantity', scopedSlots: { customRender: 'quantity' }, width: 70 },
        { title: '到账', dataIndex: 'cashAmount', width: 90 },
        { title: '状态', dataIndex: 'status', scopedSlots: { customRender: 'status' }, width: 80 },
        { title: '提交时间', dataIndex: 'createTime', width: 160 },
        { title: '操作', scopedSlots: { customRender: 'operation' }, width: 220 }
      ],
      phraseColumns: [
        { title: '标题', dataIndex: 'title', width: 120 },
        { title: '内容', dataIndex: 'content', ellipsis: true },
        { title: '排序', dataIndex: 'sort', width: 70 },
        { title: '状态', dataIndex: 'status', scopedSlots: { customRender: 'status' }, width: 80 },
        { title: '操作', scopedSlots: { customRender: 'phraseOp' }, width: 120 }
      ]
    }
  },
  computed: {
    ...mapGetters(['auditRedeemPending']),
    /** 到账/券加成固定奈拉，与 Redeem Value 面额国家符号区分 */
    payoutCurrencySymbol() {
      return (this.detail && this.detail.cashCurrencySymbol) || '₦'
    }
  },
  created() {
    this.getList()
    this.startListPoll()
  },
  beforeDestroy() {
    this.stopListPoll()
  },
  watch: {
    selectedPhraseKey(key) {
      this.applySelectedPhrase(key)
    },
    auditRedeemPending() {
      this.getList()
    }
  },
  methods: {
    startListPoll() {
      this.stopListPoll()
      this.listPollTimer = setInterval(() => {
        if (!this.loading && !this.rejectVisible && !this.detailVisible) {
          this.getList(true)
        }
      }, LIST_POLL_MS)
    },
    stopListPoll() {
      if (this.listPollTimer) {
        clearInterval(this.listPollTimer)
        this.listPollTimer = null
      }
    },
    splitImageUrls(urls) {
      if (!urls) return []
      return String(urls).split(',').map(u => u.trim()).filter(Boolean)
    },
    formatFaceValue(detail) {
      return this.formatFaceValues(detail && detail.cards, detail)
    },
    formatCardFaceValue(card, detail) {
      if (card && card.faceValue != null) {
        const symbol = (detail && detail.currencySymbol) || ''
        return symbol + card.faceValue
      }
      return '—'
    },
    /** 本张卡计算到账时使用的默认价格 */
    formatCardRate(card) {
      if (card && card.defaultPrice != null && card.defaultPrice !== '') {
        return String(card.defaultPrice)
      }
      return '—'
    },
    formatCouponBonus(detail) {
      const bonus = Number(detail && detail.couponBonus)
      if (Number.isNaN(bonus) || bonus <= 0) return '无'
      return this.payoutCurrencySymbol + bonus.toFixed(2)
    },
    formatFaceValues(cards, detail) {
      const list = cards || []
      const values = list.map(c => c && c.faceValue).filter(v => v != null)
      if (values.length === 0) {
        if (detail && detail.faceValue != null) {
          const symbol = detail.currencySymbol || ''
          return symbol + detail.faceValue
        }
        return '—'
      }
      const symbol = (detail && detail.currencySymbol) || ''
      const unique = []
      values.forEach(v => {
        const s = String(v)
        if (!unique.includes(s)) unique.push(s)
      })
      return unique.map(v => symbol + v).join(' / ')
    },
    onRejectImagesChange(val) {
      if (typeof val === 'string') {
        this.rejectImageUrls = val
      } else if (val && typeof val === 'object') {
        this.rejectImageUrls = val.rejectImageUrls || ''
      }
    },
    buildPageQuery() {
      const params = {
        pageNum: this.queryParam.pageNum || 1,
        pageSize: this.queryParam.pageSize || 10
      }
      const orderNo = this.queryParam.orderNo != null ? String(this.queryParam.orderNo).trim() : ''
      if (orderNo) {
        params.orderNo = orderNo
      }
      const status = this.queryParam.status
      if (status !== undefined && status !== null && status !== '') {
        params.status = Number(status)
      }
      return params
    },
    getList(silent) {
      if (!silent) {
        this.loading = true
      }
      return pageRedeemOrder(this.buildPageQuery()).then(res => {
        this.list = (res.data && res.data.records) || []
        this.total = (res.data && res.data.total) || 0
      }).finally(() => {
        if (!silent) {
          this.loading = false
        }
      })
    },
    /** 审核操作后：关弹窗 + 刷列表 + 刷待办 */
    refreshAfterAudit() {
      this.detailVisible = false
      this.closeReject()
      this.$store.dispatch('auditReminder/fetchAuditPendingCount')
      return this.getList()
    },
    loadRejectPhrases() {
      this.phraseLoading = true
      return listRejectPhrases(BIZ_TYPE_REDEEM, false).then(res => {
        this.rejectPhrases = res.data || []
      }).finally(() => { this.phraseLoading = false })
    },
    onStatusChange(val) {
      if (val === undefined || val === null || val === '') {
        this.queryParam.status = undefined
      }
      this.handleQuery()
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = { pageNum: 1, pageSize: 10, status: undefined, orderNo: undefined }
      this.getList()
    },
    changePage(page, pageSize) {
      this.queryParam.pageNum = page
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(page, pageSize) {
      this.queryParam.pageNum = 1
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    showDetail(record) {
      this.detailVisible = true
      this.detailLoading = true
      this.detail = null
      getRedeemOrderDetail(record.id).then(res => {
        this.detail = res.data
      }).finally(() => { this.detailLoading = false })
    },
    isProcessable(record) {
      return record && record.status === 1
    },
    needsClaim(record) {
      return this.isProcessable(record) && !record.claimedByMe
    },
    canAuditActions(record) {
      return this.isProcessable(record) && !!record.claimedByMe
    },
    claimOrder(record) {
      claimRedeemOrder(record.id).then(() => {
        this.$message.success('接单成功')
        this.$store.dispatch('auditReminder/fetchAuditPendingCount')
        return this.getList().then(() => {
          this.showDetail(record)
        })
      }).catch(() => {
        this.getList()
      })
    },
    handleAudit(record, status) {
      const self = this
      this.$confirm({
        title: status === 2 ? '确认通过该订单？' : '确认驳回？',
        onOk() {
          return auditRedeemOrder({ orderId: record.id, status, rejectReason: self.rejectReason }).then(() => {
            self.$message.success('操作成功')
            return self.refreshAfterAudit()
          })
        }
      })
    },
    showReject(record) {
      this.currentRecord = record
      this.rejectReason = ''
      this.rejectImageUrls = ''
      this.selectedPhraseKey = 'custom'
      this.rejectVisible = true
      this.loadRejectPhrases().then(() => {
        if (this.rejectPhrases.length) {
          this.selectedPhraseKey = 'p-' + this.rejectPhrases[0].id
        }
      })
    },
    closeReject() {
      this.rejectVisible = false
      this.rejectReason = ''
      this.rejectImageUrls = ''
      this.selectedPhraseKey = 'custom'
    },
    applySelectedPhrase(key) {
      if (!key || key === 'custom') {
        return
      }
      const id = String(key).replace(/^p-/, '')
      const item = this.rejectPhrases.find(p => String(p.id) === id)
      if (item) {
        this.rejectReason = item.content || ''
      }
    },
    confirmReject() {
      const reason = (this.rejectReason || '').trim()
      if (!reason) {
        this.$message.warning('请填写驳回原因')
        return Promise.reject(new Error('empty reason'))
      }
      this.rejectSubmitting = true
      return auditRedeemOrder({
        orderId: this.currentRecord.id,
        status: 3,
        rejectReason: reason,
        rejectImageUrls: (this.rejectImageUrls || '').trim()
      }).then(() => {
        this.$message.success('已驳回')
        return this.refreshAfterAudit()
      }).finally(() => { this.rejectSubmitting = false })
    },
    openPhraseManage() {
      this.phraseManageVisible = true
      this.loadPhraseManageList()
    },
    loadPhraseManageList() {
      this.phraseManageLoading = true
      listRejectPhrases(BIZ_TYPE_REDEEM, true).then(res => {
        this.phraseManageList = res.data || []
      }).finally(() => { this.phraseManageLoading = false })
    },
    openPhraseForm(record) {
      if (record) {
        this.phraseForm = { ...record }
      } else {
        this.phraseForm = { bizType: BIZ_TYPE_REDEEM, title: '', content: '', sort: 0, status: 1 }
      }
      this.phraseFormVisible = true
    },
    submitPhraseForm() {
      const form = this.phraseForm
      if (!(form.title || '').trim()) {
        this.$message.warning('请填写标题')
        return
      }
      if (!(form.content || '').trim()) {
        this.$message.warning('请填写话术内容')
        return
      }
      this.phraseFormSubmitting = true
      saveRejectPhrase({
        ...form,
        bizType: BIZ_TYPE_REDEEM,
        title: form.title.trim(),
        content: form.content.trim()
      }).then(() => {
        this.$message.success('保存成功')
        this.phraseFormVisible = false
        this.loadPhraseManageList()
      }).finally(() => { this.phraseFormSubmitting = false })
    },
    removePhrase(id) {
      deleteRejectPhrase(id).then(() => {
        this.$message.success('已删除')
        this.loadPhraseManageList()
      })
    }
  }
}
</script>

<style scoped>
.card-block {
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 12px;
}
.detail-summary {
  margin-bottom: 16px;
}
.cards-section-title {
  font-weight: 600;
  margin: 16px 0 12px;
}
.card-desc {
  margin-bottom: 8px;
}
.card-title {
  font-weight: 600;
  margin-bottom: 8px;
}
.card-img {
  width: 64px;
  height: 64px;
  object-fit: cover;
  margin-right: 8px;
  border-radius: 4px;
}
.card-img-lg {
  width: 120px;
  height: 120px;
  object-fit: cover;
  margin-right: 10px;
  margin-bottom: 8px;
  border-radius: 6px;
  border: 1px solid #f0f0f0;
}
.img-label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
  margin-bottom: 6px;
}
.no-img {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
}
.card-img.clickable {
  cursor: pointer;
}
.img-row {
  margin-top: 8px;
}
.reject-block {
  border: 1px solid #ffccc7;
  background: #fff2f0;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 12px;
}
.phrase-radio {
  margin-bottom: 8px;
}
.claim-busy {
  color: #fa8c16;
  white-space: nowrap;
}
</style>
